module.exports = __webpack_public_path__ + "static/media/download-outlined.5428c7c6.svg";